import mixins from '@synergycms_core/less/mixins';

export default {
  header: {},
  buttonText: {},
  pencilIcon: {
    color: (data) => data.headerColorIcons
  },
  hotelNameContainer: {
    position: 'relative',
    display: 'flex',
    minWidth: 0,
    '& $headerTitleStars': {
      marginLeft: '5px',
      color: (data) => data.headerColorDynamicText,
      '&:lang(ar)': {
        marginLeft: 0,
        float: 'left',
        marginRight: '5px'
      }
    }
  },
  headerTitleStars: {},
  hotelNameTitle: {},
  downArrow: {},
  content: {},
  contentModule: {},
  roundedThemeV2: {},
  defaultStyleKY: {},
  multiHotelHeader: {
    //maxWidth: '1170px',
    textAlign: 'left',
    padding: 0,
    '&:lang(ar)': {
      textAlign: 'right'
    }
  },
  yearsTooltip: {
    textAlign: 'center',
    textTransform: 'uppercase',
    position: 'absolute',
    maxWidth: '200px',
    display: 'table',
    backgroundColor: '#fc0',
    font: "11px 'Roboto', sans-serif",
    color: '#333',
    padding: '20px 15px',
    zIndex: '700',
    '@media (max-width:600px)': {
      paddingTop: '25px'
    }
  },
  wrapperHeader: {
    width: '100%',
    zIndex: '500',
    position: 'absolute',
    borderBottom: '1px solid #D8D8D8',
    '@media (max-width: 1100px)': {
      height: 'unset'
    }
  },
  closeButton: data => ({
    position: 'absolute',
    top: '20px',
    right: '5px',
    zIndex: '501',
    color: data.mainColor,
    font: '16px/1px Icons',
    marginTop: '-8px',
    '&:lang(ar)': {
      right: 'auto',
      left: '10px'
    },
    [`@media (min-width: ${data.modalBreak}px)`]: {
      marginTop: '-4px',
      top: '50%',
      right: '10px'
    }
  }),
  closeButtonFather: {
    position: 'absolute',
    top: '0',
    bottom: '0',
    right: '0',
    left: '0'
  },
  closeButtonContainer: {
    position: 'relative',
    maxWidth: '1030px',
    margin: '0 auto',
    top: '50%'
  },
  headerContainer: {
    margin: '0 auto',
    textAlign: 'left',
    maxWidth: '1170px',
    minHeight: '42px',
    '&:lang(ar)': {
      textAlign: 'right'
    }
  },
  mapFilters: data => ({
    '& $header': {
      padding: '0',
      textAlign: 'left',
      color: '#000',
      zIndex: '500',
      '&:lang(ar)': {
        textAlign: 'right'
      },
      '& $multiHotelHeader': {
        borderBottom: '1px solid #D8D8D8'
      },
      '&$minimalHeader': {
        '&$hasEngine': {
          [`@media (max-width: 1100px) and (min-width: ${data.modalBreak}px)`]: {
            '&:before': {
              top: '36%'
            }
          }
        }
      },
      '&$roundedThemeV2, &$defaultStyleKY': {
        '& $multiHotelHeader': {
          padding: '10px'
        }
      }
    }
  }),
  hidePadding: {
    padding: '0 !important'
  },
  infoContainer: data => ({
    width: '100%',
    position: 'relative',
    display: 'table',
    [`@media (min-width: ${data.modalBreak}px) and (max-width: 1100px)`]: {
      '& > button': {
        order: '1'
      },
      '& $leftContainer': {
        order: '2'
      },
      '& $userConfigsContainer': {
        order: '3'
      }
    }
  }),
  fixedEngine: {
    '&$infoContainer': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '15px'
    }
  },
  fixedEngineContainer: {
    flex: '1 1 auto',
    minWidth: 0
  },
  leftContainer: {
    verticalAlign: 'middle',
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center'
  },
  locContainer: data => ({
    padding: '0 20px 0 30px',
    display: 'table-cell',
    alignItems: 'center',
    position: 'relative',
    font: '400 16px ' + data.fontFamily1,
    [`@media (max-width: calc(${data.modalBreak}px - 1px))`]: {
      paddingBottom: '7px',
      paddingRight: '10px'
    },
    [`@media (min-width: ${data.modalBreak}px)`]: {
      height: '33px'
    },
    '@media (min-width: 1101px) and (max-width: 1150px)': {
      padding: '0 15px 0 15px'
    },
    '&:lang(ar)': {
      textAlign: 'right',
      paddingLeft: '20px',
      paddingRight: '30px'
    },
    '&$minLocationContainer': {
      paddingLeft: 'unset'
    }
  }),
  calendarIcon: {
    color: (data) => data.headerColorIcons
  },
  dateContainer: data =>({
    padding: '0 20px 0 30px',
    display: 'table-cell',
    verticalAlign: 'middle',
    position: 'relative',
    font: '400 16px ' + data.fontFamily1,
    textAlign: 'left',
    [`@media (max-width: calc(${data.modalBreak}px - 1px))`]: {
      paddingBottom: '7px'
    },
    '&:lang(ar)': {
      textAlign: 'right',
      paddingLeft: '20px',
      paddingRight: '30px'
    }
  }),
  roomContainer: data => ({
    padding: '0 20px 0 30px',
    display: 'table-cell',
    verticalAlign: 'middle',
    position: 'relative',
    font: '400 16px ' + data.fontFamily1,
    textAlign: 'left',
    '& $headerTitle': {
      '&:lang(ar)': {
        display: 'inline-block'
      }
    },
    [`@media (max-width: calc(${data.modalBreak}px - 1px))`]: {
      paddingBottom: '7px',
      padding: '0 5px',
      borderLeft: '1px solid ' + data.headerColorDynamicText,
      borderRight: '1px solid ' + data.headerColorDynamicText,
      width: '60px',
      textAlign: 'center',
      top: '1px'
    },
    '&:lang(ar)': {
      textAlign: 'right',
      paddingLeft: '20px',
      paddingRight: '30px',
      [`@media (max-width: calc(${data.modalBreak}px - 1px))`]: {
        paddingRight: '5px',
        paddingLeft: '5px'
      }
    }
  }),
  modifyTitle: {},
  modifySearch: {
    verticalAlign: 'middle',
    display: 'table-cell',
    textAlign: 'center',
    boxSizing: 'border-box',
    '& $modifyTitle': {
      fontWeight: 'bold'
    },
    '&:not($minModifySearchBtn)': {
      paddingLeft: '17px'
    },
    '& > button': {
      height: '41px',
      width: '153px',
      position: 'relative',
      padding: '0 32px',
      borderColor: (data) => data.headerColorIcons,
      color: (data) => data.headerColorIcons,
      ...mixins.boxSizing(),
      '& $buttonText': {
        font: (data) => '300 13px ' + data.fontFamily1
      },
      '& $pencilIcon': {
        font: '17px/1px Icons',
        position: 'absolute',
        left: '0',
        top: '50%',
        width: '40px',
        '&:lang(ar)': {
          left: 'auto',
          right: 0
        }
      },
      '&:not($minModifySearchBtn)': {
        width: '100%',
        padding: '0 15px 0 35px',
        maxWidth: '200px',
        height: '42px',
        '@media (max-width: 1100px)': {
          border: 'none',
          width: '42px',
          height: '42px',
          padding: '0',
          '&:hover': {
            background: 'transparent',
            border: 'none'
          }
        }
      },
      '&:hover': {
        borderColor: 'transparent'
      },
      '&:lang(ar)': {
        paddingLeft: '15px',
        paddingRight: '35px'
      }
    },
    '& $minModifySearchBtn': {
      '& $pencilIcon': {
        fopntSize: '20px',
        position: 'unset',
      },
      [`@media (max-width: 1200px)`]: {
          maxWidth: '48px',
          padding: '0',
      },
    },
    '&:lang(ar)': {
      paddingLeft: '4px',
      paddingRight: '17px'
    }
  },
  stepContent: {
    display: 'table-cell',
    padding: '0 0 0 10px',
    verticalAlign: 'middle',
    '&:lang(ar)': {
      paddingLeft: '0',
      paddingRight: '10px'
    },
    '&:empty': {
      display: 'none'
    }
  },
  supTitle: data => ({
    font: '300 13px ' + data.fontFamily1,
    display: 'block',
    color: data.headerColorFont,
    textAlign: 'left',
    '&:lang(ar)': {
      textAlign: 'right',
      [`@media (max-width: calc(${data.modalBreak}px - 1px))`]: {
        float: 'right'
      }
    },
    [`@media (max-width: calc(${data.modalBreak}px - 1px))`]: {
      display: 'inline'
    }
  }),
  confirmationHeader: {
    padding: '0 !important'
  },
  headerTitle: data =>({
    font: '400 15px ' + data.fontFamily1,
    color: data.headerColorDynamicText,
    [`@media (max-width: calc(${data.modalBreak}px - 1px))`]: {
      fontSize: '13px'
    }
  }),
  nightsTitle: {
    display: 'block',
    overflow: 'hidden',
    minWidth: '0px',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  },
  hotelName: data => ({
    display: 'block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    minWidth: 0,
    [`@media (max-width: calc(${data.modalBreak}px - 1px))`]: {
      font: '400 16px "Droid Serif"'
    }
  }),
  starBadge: {
    display: 'inline-flex',
    verticalAlign: 'middle',
    flexShrink: 0,
    marginLeft: '3px'
  },
  starBadgeHalf: {
    display: 'inline-flex',
    verticalAlign: 'middle',
    overflow: 'hidden',
    width: '0.55em'
  },
  starBadgeHalfIcon: {
    flexShrink: 0
  },
  absoluteIcon: {
    position: 'absolute',
    left: '0',
    top: '50%',
    marginTop: '-11px',
    color: (data) => data.headerColorIcons,
    '&:lang(ar)': {
      left: 'auto',
      right: '0'
    }
  },
  roomIcon: data => ({
    position: 'absolute',
    left: '0',
    top: '50%',
    marginTop: '-11px',
    color: data.headerColorIcons,
    [`@media (max-width: calc(${data.modalBreak}px - 1px))`]: {
      position: 'static'
    },
    '&:lang(ar)': {
      left: 'auto',
      right: '0'
    }
  }),
  roomIconMobile: {
    position: 'absolute',
    left: '-14px',
    top: '59%',
    marginTop: '-11px',
    width: '19px',
    height: '19px',
    fill: (data) => data.headerColorIcons,
    '&:lang(ar)': {
      left: 'auto',
      right: '0'
    }
  },
  absoluteSvg: data => ({
    position: 'absolute',
    left: '0',
    top: '50%',
    marginTop: '-11px',
    fill: data.headerColorIcons,
    width: '21px',
    [`@media (max-width: calc(${data.modalBreak}px - 1px))`]: {
      width: '16px'
    },
    '&:lang(ar)': {
      left: 'auto',
      right: '0'
    }
  }),
  roomQuantity: data =>({
    fontSize: '16px',
    marginRight: '10px',
    color: data.headerColorDynamicText,
    [`@media (max-width: calc(${data.modalBreak}px - 1px))`]: {
      fontSize: '13px',
      marginLeft: '8px'
    },
    '&:lang(ar)': {
      [`@media (max-width: calc(${data.modalBreak}px - 1px))`]: {
        marginLeft: '0',
        marginRight: '4px'
      }
    }
  }),
  minimalRoomQuantityContainer: {},
  minimalRoomOccupContainer: {},
  roomQuantityContainer: data => ({
    display: 'inline',
    '&$minimalRoomQuantityContainer': {
      marginLeft: '15px',
      '& $headerTitle': {
        position: 'relative',
        top: '1.5px',
        color: data.headerColorIcons,
        [`@media (max-width: calc(${data.modalBreak}px - 1px))`]: {
          top: '3px'
        }
      },
      [`@media (min-width: ${data.modalBreak}px)`]: {
        marginLeft: '0px',
        display: 'flex',
        alignItems: 'center'
      }
    },
    '&$minimalRoomOccupContainer': {
      '& $headerTitle': {
        [`@media (max-width: calc(${data.modalBreak}px - 1px))`]: {
          position: 'relative',
          top: '2px'
        }
      },
      [`@media (min-width: ${data.modalBreak}px)`]: {
        display: 'flex',
        alignItems: 'center'
      }
    },
    [`@media (max-width: calc(${data.modalBreak}px - 1px))`]: {
      display: 'inline-block'
    },
    '& $headerTitle': {
      marginRight: '10px',
      [`@media (max-width: calc(${data.modalBreak}px - 1px))`]: {
        margin: '0',
        float: 'left',
        color: data.headerColorIcons,
        fontSize: '16px'
      },
      '&:lang(ar)': {
        [`@media (max-width: calc(${data.modalBreak}px - 1px))`]: {
          float: 'right'
        }
      }
    }
  }),
  engineClosedTitles: data => ({
    [`@media (min-width: ${data.modalBreak}px)`]: {
      fontSize: '15px'
    }
  }),
  floatedContainer: data => ({
    display: 'table-cell',
    verticalAlign: 'middle',
    '& $locContainer': {
      [`@media (max-width: calc(${data.modalBreak}px - 1px))`]: {
        display: 'block'
      }
    },
    '& dateContainer': {
      [`@media (max-width: calc(${data.modalBreak}px - 1px))`]: {
        display: 'block'
      }
    },
    '& $hotelNameContainer': {
      [`@media (max-width: calc(${data.modalBreak}px - 1px))`]: {
        textOverflow: 'ellipsis',
        whiteSpace: 'break-spaces',
        overflow: 'hidden',
        width: '100%',
        display: 'block',
        color: '#fff',
        textAlign: 'left'
      }
    },
    [`@media (min-width: ${data.modalBreak}px)`]: {
      display: 'flex',
      height: '33px',
      alignItems: 'center',
      width: 'unset'
    }
  }),
  datePickerButton: {
    width: '100%',
    '& $tableContainer': {
      display: 'table',
      width: '100%'
    }
  },
  tableContainer: {
    display: 'table-cell',
    verticalAlign: 'top',
    paddingTop: '3px',
    '&:last-of-type': {
      paddingTop: '3px',
      '&$miniTableContainer': {
        padding: '0 10px'
      },
      '& button': {
        textAlign: 'left',
        '&:lang(ar)': {
          textAlign: 'right'
        },
        '& $floatedContainer': {
          '& $headerTitle': {
            position: 'relative',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            display: 'block',
            maxWidth: '150px'
          }
        }
      },
      '&:lang(ar)': {
        textAlign: 'left'
      }
    },
    '&$miniTableContainer': {
      padding: 'unset',
      '&$priceMoreDetails': {
        bottom: '0',
        '& $floatedContainer': {
          '& $resumePrice': {
            paddingBottom: '11px'
          }
        }
      }
    }
  },
  leftButton: {
    '& $locContainer': {
      paddingLeft: '30px',
      paddingRight: 0,
      '&:lang(ar)': {
        paddingLeft: '0',
        paddingRight: '20px'
      }
    },
    '& $dateContainer': {
      paddingLeft: '30px',
      paddingRight: 0,
      '&:lang(ar)': {
        paddingLeft: '0',
        paddingRight: '20px'
      }
    }
  },
  resumePrice: {
    font: (data) => 'bold 18px ' + data.fontFamily1,
    color: (data) => data.headerColorDynamicText,
    paddingBottom: '12px',
    display: 'block',
    textAlign: 'right',
    '&:lang(ar)': {
      paddingLeft: '29px',
      paddingRight: '0',
      textAlign: 'left'
    }
  },
  arrowContainer: {
    position: 'relative',
    textAlign: 'right',
    '& $downArrow': {
      position: 'absolute',
      bottom: '0',
      top: '0',
      left: '70%',
      fill: (data) => data.mainColor,
      marginBottom: '-11px',
      '&:lang(ar)': {
        right: 'auto',
        left: 0
      }
    }
  },
  resumeModalStyle: {
    position: 'fixed',
    top: '0',
    left: '0',
    bottom: '0',
    right: '0',
    padding: '0',
    background: '#fff',
    zIndex: '600',
    overflow: 'auto',
    ...mixins.transition('all 0.5s')
  },
  summaryModal: {
    '& $header': {
      display: 'block'
    },
    '& $content': {
      '& $contentModule': {
        ...mixins.boxSizing()
      }
    }
  },
  summaryCloseButton: {
    position: 'fixed',
    right: '10px',
    top: '10px',
    height: '24px',
    width: '24px',
    background: 'none',
    border: '0',
    zIndex: '2',
    '& > span': {
      color: (data) => data.mainColor,
      fontWeight: 'bold'
    },
    '&:lang(ar)': {
      right: 'auto',
      left: '10px'
    }
  },
  opennedEngine: {
    zIndex: 500,
    position: 'relative',
    width: '100%',
    '& $wrapperHeader': {
      height: 'unset',
      '& $minimalHeader': {
        '& $multiHotelHeader': {
          '& $infoContainer': {
            display: 'table',
            backgroundColor: (data) => data.backgroundColor
          }
        },
        '& $headerContainer': {
          maxWidth: '1170px',
          padding: 'unset',
          '& $infoContainer': {
            display: 'table',
            backgroundColor: (data) => data.backgroundColor
          }
        },
        '&$portalDesignV2': {
          '& $multiHotelHeader': {
            '& $infoContainer': {
              display: 'table',
              backgroundColor: 'inherit'
            }
          },
        }
      }
    }
  },
  closedEngine: data => ({
    zIndex: 55,
    position: 'relative',
    width: '100%',
    '& $wrapperHeader': {
      '& $minimalHeader': {
        '&:not($portalDesignV2)':{
          '& $multiHotelHeader': {
            [`@media (min-width: ${data.modalBreak}px)`]: {
              padding: '15px 35px',
              maxWidth: 'unset'
            }
          },
        },
        '&$portalDesignV2': {
          '& $multiHotelHeader': {
            [`@media (min-width: ${data.modalBreak}px)`]:{
              padding: '0 35px',
            }
          },
        }
      }
    }
  }),
  headerLogo: data => ({
    height: '25px',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      height: '30px'
    }
  }),
  phoneBox: {},
  phoneContainer: {},
  userConfigsContainer: data => ({
    display: 'flex',
    gap: '5px',
    alignItems: 'center',
    '& > div': {
      width: '24.5px',
      height: '24.5px'
    },
    '& > div:last-child': {
      width: '38px',
      height: '24.5px',
      [`@media (min-width: ${data.modalBreak}px) and (max-width: 1280px)`]: {
        width: '42px'
      }
    },
    '@media (min-width: 1281px)': {
      '& > div:last-child': {
        width: 'unset',
        height: 'unset'
      }
    },

    /* ESTILOS AÑADIDOS PARA AGRANDAR ZONA DE CLICK BOTONES -> LOGIN, PHONE */
    '& $loginContainer': {
      width: '40px',
      height: '40px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '& > div': {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& > button': {
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }
      }
    },
    '& $phoneContainer': {
      width: '40px',
      height: '40px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginRight: '5px',
      position: 'relative',
      [`@media (min-width: ${data.modalBreak}px)`]: {
        marginRight: '0px'
      },
      '& $phoneBox': {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& > div > div > svg': {
          position: 'relative',
          top: '2px'
        }
      }
    }
  }),
  /* ---------------------- */

  loginContainer: {
    width: '24.5px',
    height: '24.5px',
    '& > div > button > div': {
      '& div > svg': {
        fill: (data) => data.headerColorIcons
      }
    }
  },
  langSelectWrapper: {},
  langSelectorContainer: data =>({
    color: '#000',
    position: 'relative',
    '& $langSelectWrapper': {
      right: '3px',
      zIndex: '302',
      textAlign: 'left',
      background: '#fff',
      margin: '0 auto 0',
      boxSizing: 'border-box',
      border: '1px solid #d8d8d8',
      position: 'relative',
      width: '40px',
      [`@media (min-width: ${data.modalBreak}px) and (max-width: 1280px)`]: {
        right: '-3px'
      },
      '@media (min-width: 1281px)': {
        position: 'absolute',
        right: '0',
        zIndex: '302',
        top: '100%',
        textAlign: 'left',
        background: '#fff',
        margin: '5px auto 0',
        left: '-15px',
        width: 'fit-content',
        boxSizing: 'border-box',
        border: '1px solid #d8d8d8'
      },
      '& li': {
        display: 'inline-block',
        marginBottom: '10px',
        marginLeft: '10px',
        marginRight: '10px',
        '@media (min-width: 1281px)': {
          display: 'inline-block',
          marginBottom: '10px',
          marginLeft: '20px',
          marginRight: '20px'
        },
        '& a': {
          color: '#000',
          font: "14px 'Open Sans',sans-serif"
        },
        '& a:hover': {
          textDecoration: 'none'
        },
        '&:first-child': {
          marginTop: '10px'
        }
      }
    }
  }),
  langSelected: {
    font: "14px 'Open Sans',sans-serif"
  },
  langSelectorEnter: {
    transition: 'max-height 0ms ease-out',
    maxHeight: '0'
  },
  langSelectorEnterActive: {
    maxHeight: '300px',
    transition: 'max-height 1000ms ease-out',
    overflow: 'hidden'
  },
  langSelectorLeave: {
    maxHeight: '300px',
    transition: 'max-height 1000ms ease-out',
    overflow: 'hidden'
  },
  langSelectorLeaveActive: {
    transition: 'max-height 1000ms ease-out',
    maxHeight: '0'
  },
  minimalDateContainer: data => ({
    position: 'relative',
    '@media (min-width: 1101px)': {
      height: '33px',
      display: 'flex',
      alignItems: 'center'
    },
    '&:after': {
      top: '0',
      right: '0',
      width: '0.5px',
      bottom: '0',
      height: '100%',
      content: "''",
      position: 'absolute',
      backgroundColor: '#d8d8d8'
    },
    '& $dateContainer': {
      [`@media (min-width: ${data.modalBreak}px)`]: {
        display: 'flex',
        alignItems: 'center',
        padding: '0 25px 0 25px'
      },
      '@media (min-width: 1101px) and (max-width: 1150px)': {
        padding: '0 15px 0 15px'
      },
      '& $calendarIcon': {
        paddingRight: '10px',
        color: data.headerColorIcons
      },
      '& $engineClosedTitles': {
        [`@media (min-width: ${data.modalBreak}px) and (max-width: 1100px)`]: {
          position: 'relative',
          top: '1px'
        }
      }
    }
  }),
  minimalRoomContainer: data => ({
    position: 'relative',
    gap: '15px',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      display: 'flex',
      height: '33px',
      alignItems: 'center',
    },
    '& $roomQuantity': {
      marginRight: 'unset',
      [`@media (max-width: calc(${data.modalBreak}px - 1px))`]: {
        position: 'relative',
        top: '6px',
        fontSize: '14px'
      }
    },
    '& $minimalRoomOccupContainer': {
      '& $engineClosedTitles': {
        [`@media (min-width: ${data.modalBreak}px) and (max-width: 1100px)`]: {
          position: 'relative',
          top: '1px'
        }
      }
    },
    '& $minimalRoomQuantityContainer': {
      '& $engineClosedTitles': {
        [`@media (min-width: ${data.modalBreak}px) and (max-width: 1100px)`]: {
          position: 'relative',
          top: '1px'
        }
      }
    },
    '&$roomContainer': {
      padding: '0 25px 0 25px',
      '& $headerTitle': {
        color: data.headerColorIcons
      },
      '& $calendarIcon': {
        position: 'relative',
        top: '2px'
      },
      '@media (min-width: 1101px) and (max-width: 1150px)': {
        padding: '0 15px 0 15px'
      }
    }
  }),
  promoCodeContainer: {
    padding: '0 0 0 15px',
    '@media (min-width: 1101px)': {
      height: '33px',
      display: 'flex',
      alignItems: 'center'
    },
    '& $headerTitle': {
      color: (data) => data.headerColorIcons
    }
  },
  destinationIcon: {},
  minLocationContainer: {
    position: 'relative',
    display: 'flex',
    '& $destinationIcon': {
      marginRight: '5px',
      color: (data) => data.headerColorIcons
    },
    '@media (min-width: 1101px)': {
      height: '33px',
      display: 'flex',
      alignItems: 'center'
    },
    '&:after': {
      top: '0',
      right: '0',
      width: '0.5px',
      bottom: '0',
      height: '100%',
      content: "''",
      position: 'absolute',
      backgroundColor: '#d8d8d8'
    }
  },
  minOccup: {},
  markerIcon: {},
  minSvgIcon: {
    marginLeft: '20px',
    '&$minOccup': {
      top: '33%',
      width: '33px',
      height: '33px'
    },
    '&$markerIcon': {
      marginLeft: 'unset',
      top: '40%',
      width: '25px'
    }
  },
  promoIcon: {
    fill: (data) => data.headerColorIcons,
    width: '21px',
    marginLeft: 'unset'
  },
  minModifySearchBtn: {
    font: (data) => '600 16px ' + data.fontFamily1
  },
  phoneDispoEngine: {
    fill: (data) => data.headerColorIcons
  },
  up: {},
  searchOptionsButtonIcon: {},
  langSelectorIcon: {},
  down: {},
  langSelectorBtn: data =>({
    height: '24.5px',
    position: 'relative',
    paddingRight: '20px',
    [`@media (min-width: ${data.modalBreak}px)`]: {
      marginLeft: '5px'
    },
    '&$up': {
      '& $langSelectorIcon': {
        marginLeft: '-5px',
        position: 'absolute',
        display: 'block',
        left: '70%',
        pointerEvents: 'none',
        '@media (min-width: 1281px)': {
          marginLeft: '5px'
        }
      }
    },
    '&$down': {
      '& $langSelectorIcon': {
        marginLeft: '-5px',
        position: 'absolute',
        display: 'block',
        rotate: '180deg',
        left: '70%',
        pointerEvents: 'none',
        '@media (min-width: 1281px)': {
          marginLeft: '5px'
        }
      }
    }
  }),
  mobilePreheaderContainer: {},
  mobilePreheader: {
    borderBottom: '1px solid #D8D8D8',
    padding: '10px',
    '& $mobilePreheaderContainer': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      '& $userConfigsContainer': {
        marginRight: '0',
        height: '40px'
      },
      '& > button': {
        height: '40px'
      }
    },
    '& + $leftContainer': {
      padding: '10px',
      marginTop: 'unset',
      width: 'unset',
      position: 'relative',
      display: 'flex',
      justifyContent: 'space-between'
    }
  },
  mobileRoomInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    width: '40%',
    alignSelf: 'stretch',
    justifyContent: 'space-between',
    '& $roomContainer': {
      width: 'unset',
      border: 'unset',
      padding: '5px',
      paddingBottom: '9px',
      paddingLeft: '0'
    }
  },
  mobileTableContainer: {
    '&$tableContainer': {
      display: 'flex',
      width: 'unset',
      alignItems: 'center',
      '& $floatedContainer': {
        width: '60%'
      },
      '&:last-of-type': {
        padding: '10px'
      }
    }
  },
  noPadding: {
    '&$header': {
      padding: 'unset'
    }
  },
  mobileLocContainer: {
    '&$locContainer': {
      paddingLeft: 0
    }
  },
  mobileDateContainer: data => ({
    '&$dateContainer': {
      padding: '0',
      display: ' flex',
      alignItems: 'center'
    },
    '& $headerTitle': {
      [`@media (max-width: calc(${data.modalBreak}px - 1px))`]: {
        fontSize: '14px',
        position: 'relative',
        bottom: '1px',
      },
      '&:lang(de)': {
        [`@media (max-width: calc(${data.modalBreak}px - 1px))`]: {
          maxWidth: '72px',
          width: '100%',
        },
      }
    },
    '& $nightsTitle': {
      [`@media (max-width: calc(${data.modalBreak}px - 1px))`]: {
        fontSize: '14px',
        marginLeft: '4px',
        position: 'relative',
        bottom: '2px',
        color: '#000',
        fontWeight: '300'
      }
    },
    '& $supTitle': {
      marginRight: '8px',
      position: 'relative',
      bottom: '3px'
    }
  }),
  minimalHeader: data =>({
    '&$header': {
      padding: 'unset',
      '& $headerContainer': {
        minHeight: 'unset',
        maxWidth: 'unset',
        [`@media (min-width: ${data.modalBreak}px)`]: {
          padding: '15px 35px'
        },
        '& $infoContainer': {
          display: 'flex',
          flexDirection: 'column',
          [`@media (min-width: ${data.modalBreak}px)`]: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center'
          },
        }
      },
      '&$portalDesignV2': {
        [`@media (min-width: ${data.modalBreak}px)`]: {
          padding: '10px 35px'
        },
      }
    },
    '& $multiHotelHeader': {
      margin: '0 auto',
      '& $infoContainer': {
        display: 'flex',
        flexDirection: 'column',
        [`@media (min-width: ${data.modalBreak}px)`]: {
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center'
        },
      }
    },
    '&:not($portalDesignV2)': {
      '& $multiHotelHeader': {
        '& $infoContainer': {
          '& $leftContainer': {
            '@media (max-width: 1100px)': {
              display: 'flex',
              width: '100%',
              order: '3',
              justifyContent: 'center',
              marginLeft: '0',
              position: 'relative',
              top: '4px'
            },
            [`@media (max-width: calc(${data.modalBreak}px - 1px))`]: {
              display: 'table',
              width: '100%',
              order: '3',
              marginTop: '10px'
            }
          },
          [`@media (min-width: ${data.modalBreak}px)`]: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center'
          },
          [`@media (max-width: 1100px) and (min-width: ${data.modalBreak}px)`]: {
            gap: '15px'
          },
        },
        [`@media (min-width: ${data.modalBreak}px)`]: {
          padding: 'unset',
          maxWidth: '1170px'
        },
      }
    }
  }),
  priceMoreDetails: {
    '&$tableContainer': {
      padding: 'unset',
      position: 'relative',
      bottom: '5px'
    }
  },
  miniTableContainer: {},
  hasEngine: {},
  phoneWrapper: {
    position: 'absolute',
    top: '42px',
    padding: '10px',
    backgroundColor: '#fff',
    color: '#000',
    border: '1px solid #d8d8d8',
    zIndex: '1',
    minWidth: 'max-content',
    '& $phoneLink': {
      '&:last-of-type': {
        '& $phoneNumber': {
          marginBottom: '0'
        }
      }
    }
  },
  phoneCtn: {
    display: 'block',
    width: 'max-content',
    color: '#000',
    backgroundColor: '#fff',
    fontWeight: 400,
    font: "14px 'Open Sans', sans-serif"
  },
  phoneNumber: {
    display: 'block',
    //color: '#0073e6',
    fontWeight: 300,
    font: "14px 'Open Sans', sans-serif",
    textDecoration: 'none',
    marginBottom: '10px'
  },
  phoneLink: {
    textDecoration: 'none',
    color: '#000',
    '&:hover': {
      textDecoration: 'none'
    }
  },
  oldCtnHeaderAvail: {
    justifyContent: 'space-between'
  },
  separatorNoDispo: {
    margin: '0 5px'
  },
  containerInvalidDate: {
    '& > span': {
      '&:nth-of-type(1)': {
        marginRight: '5px'
      },
      '&:nth-of-type(3)': {
        marginLeft: '5px'
      }
    }
  },
  multiAvailHeader: {},
  newHeaderAvail: data =>({
    position: 'relative',
    '&:before': {
      content: "''",
      position: 'absolute',
      background: 'transparent'
    },
    [`@media (min-width: ${data.modalBreak}px)`]: {
      '&:before': {
        top: '-7px',
        left: '-35px',
        height: 'calc(100% + 22px)',
        width: 'calc(100% + 68px)'
      }
    },
    '@media (min-width: 1101px)': {
      '&:before': {
        top: '-15px',
        left: '0px',
        height: 'calc(100% + 30px)',
        width: '100%'
      }
    },
    '&$multiAvailHeader': {
      [`@media (min-width: ${data.modalBreak}px)`]: {
        '&:before': {
          top: '-10px',
          left: '-35px',
          height: 'calc(100% + 21px)',
          width: 'calc(100% + 68px)'
        }
      },
      '@media (min-width: 1101px)': {
        '&:before': {
          top: '-15px',
          left: '0px',
          height: 'calc(100% + 30px)',
          width: '100%'
        }
      }
    }
  }),
  oldHeaderAvail: {
    position: 'relative',
    '&:before': {
      content: "''",
      position: 'absolute',
      background: 'transparent',
      top: '-10px',
      left: '-10px',
      width: 'calc(100% + 18px)',
      height: 'calc(100% + 20px)'
    }
  },
  notAvailMonoMinimal: data =>({
    position: 'relative',
    [`@media (max-width: calc(${data.modalBreak}px - 1px))`]: {
      '&:before': {
        content: "''",
        position: 'absolute',
        background: 'transparent',
        top: '-10px',
        left: '-10px',
        height: 'calc(100% + 22px)',
        width: 'calc(100% + 18px)'
      }
    }
  }),
  oldHeaderMobileAvail: {
    position: 'relative',
    '&:before': {
      content: "''",
      position: 'absolute',
      background: 'transparent',
      top: '-13px',
      left: '-14px',
      width: 'calc(60vw + 20px)',
      height: 'calc(100% + 26px)'
    }
  },
  newHeaderMobileAvail: {
    position: 'relative',
    '&:before': {
      content: "''",
      position: 'absolute',
      background: 'transparent',
      top: '-11px',
      left: '-20px',
      width: 'calc(58vw + 20px)',
      height: 'calc(100% + 25px)'
    }
  },
  newZoneHeader: {
    position: 'relative',
    '&:before': {
      content: "''",
      position: 'absolute',
      background: 'transparent',
      top: '-13px',
      left: '-14px',
      width: 'calc(60vw + 20px)',
      height: 'calc(100% + 28px)'
    }
  },
  startDate:{},
  endDate: {},
  dateSeparator:{},
  stackedDateCont: data => ({
    gap: '16px',
    display: 'flex',
    boxSizing: 'border-box',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    font: '300 13px Roboto, sans-serif',
    color: data.headerColorDynamicText,
    '& $dateSeparator': {
      color: data.mainColor,
      fontSize: '17px',
      fontWeight: 'bold'
    },
    [`@media (min-width: ${data.modalBreak}px)`]:{
        gap: '12px',
        width: '100%',
        marginLeft: 'unset',
        paddingRight: '0px'
    }
  }),
  /* themes */
  portalDesign:{},
  portalDesignV2: data => ({
    '&$minimalHeader': {
      '& $minModifySearchBtn': {
        borderRadius: '4px',
      },
      '& $headerContainer': {
        '& $infoContainer': {
          borderRadius: '4px',
        },
        [`@media (min-width: ${data.modalBreak}px)`]: {
          padding: '0'
        },
      },
      '& $infoContainer': {
        [`@media (min-width: ${data.modalBreak}px)`]: {
          height: '48px'
        },
        [`@media (min-width: ${data.modalBreak}px) and (max-width: 1100px)`]: {
          '& $leftContainer': {
            order: '2'
          },
          '& $userConfigsContainer': {
            order: '3'
          }
        }
      },
      '& $minLocationContainer': {
        maxWidth: '240px',
        boxSizing: 'border-box',
        '& $hotelNameContainer':{
          display: 'flex',
          '& $hotelName':{
            display: 'inline-block',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '220px',
            fontWeight: '300',
            [`@media (max-width: 1200px)`]: {
              maxWidth: '100px',
            }
          },
        },
        [`@media (max-width: 1200px)`]: {
          maxWidth: '130px',
        }
      },
    },
    '& $roomContainer': {
      '&:not($promoCodeContainer)': {
        fontWeight: '300',
        [`@media (min-width: ${data.modalBreak}px)`]: {
          borderRight: '1px solid #d8d8d8',
          height: '33px',
          marginLeft: '12px',
          display: 'flex',
          alignItems: 'center',
        },
      }
    },
    '& $headerTitle':{
      fontWeight: '300',
    }
  }),
};
